export default {
  init() {
    const button = document.querySelector('.scroll-to-top');

    if (button) {
      button.addEventListener('click', function() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      });
    }
  }
};
